import React from 'react';
import CclDataTable, { CclDataTableColumnDef, CclDataTableColumnType } from '../CclDataTable';
import Toaster from "../Toaster";
import ApiDefaultRegion from "../../code/api/ApiDefaultRegion";
import DefaultRegion from "../../code/models/DefaultRegion";
import "../../css/admindefaulteditors.css";
import ButtonConfirm, { ButtonConfirmSize } from "../ButtonConfirm";

export default function AdminDefaultRegion() {
    const [toastMessage, setToastMessage] = React.useState<string>("");
    const [defaultRegionList, setDefaultRegionList] = React.useState<DefaultRegion[] | null>(null);
    const [selectedDefaultRegion, setSelectedDefaultRegion] = React.useState<DefaultRegion | null>(null);
    const [editDefaultRegion, setEditDefaultRegion] = React.useState<DefaultRegion | null>(null);
    const [anyChanges, setAnyChanges] = React.useState<boolean>(false);

    React.useEffect(() => {
        loadData();
    }, []);

    async function loadData() {
        ApiDefaultRegion.getDefaultRegions().then(data => {
            setDefaultRegionList(data);
        });
    }

    function reloadData() {
        setEditDefaultRegion(null);
        setSelectedDefaultRegion(null);
        setDefaultRegionList(null);
        loadData();
    }

    function saveChanges() {
        setToastMessage("");
        if (anyChanges && !!editDefaultRegion && !!selectedDefaultRegion) {
            let isNew = !selectedDefaultRegion.id;
            ApiDefaultRegion.updateDefaultRegion(editDefaultRegion).then(updatedItem => {
                if (!!updatedItem) {
                    selectedDefaultRegion.id = updatedItem.id;
                    selectedDefaultRegion.regionName = updatedItem.regionName;
                    selectedDefaultRegion.regionDescription = updatedItem.regionDescription;

                    setToastMessage("Default Region Saved.");

                    if (isNew) {
                        reloadData();
                    } else {
                        setEditDefaultRegion(null);
                        setSelectedDefaultRegion(null);
                        setAnyChanges(false);
                    }
                }
            });
        }
    }

    function cancelChanges() {
        setEditDefaultRegion(null);
        setSelectedDefaultRegion(null);
        setAnyChanges(false);
    }

    function addItem(): void {
        var newRow = new DefaultRegion();
        setSelectedDefaultRegion(newRow);
        setEditDefaultRegion(structuredClone(newRow));
        setAnyChanges(false);
    }

    function deleteItem(confirm: boolean) {
        if (!selectedDefaultRegion || confirm) return;
        setToastMessage("");

        ApiDefaultRegion.deleteDefaultRegion(selectedDefaultRegion.id).then(success => {
            if (success) {
                setToastMessage(`Default Region Deleted. (${selectedDefaultRegion.regionName})`);
                reloadData();
            } else {
                setToastMessage("Unable to delete default Region.");
            }
        });
    }

    function checkHasChanges() {
        var isAnyChanges = editDefaultRegion !== null &&
            (selectedDefaultRegion?.regionName !== editDefaultRegion?.regionName ||
                selectedDefaultRegion?.regionDescription !== editDefaultRegion?.regionDescription);
        setAnyChanges(isAnyChanges);
    }

    function handleRowSelect(rowData: any) {
        setSelectedDefaultRegion(rowData);
        setEditDefaultRegion(structuredClone(rowData));
        setAnyChanges(false);
    }

    const profileColumnDefs: CclDataTableColumnDef[] = [
        {
            fieldName: "id",
            title: "Region",
            visible: false,
            type: CclDataTableColumnType.Data
        }, {
            fieldName: "regionName",
            title: "Region",
            visible: true,
            type: CclDataTableColumnType.Data
        }, {
            fieldName: "regionDescription",
            title: "Description",
            visible: true,
            type: CclDataTableColumnType.Data
        }
    ];

    function buildEditor() {
        return (<React.Fragment>
            {!!editDefaultRegion && !!selectedDefaultRegion &&
                <div key={"bp" + selectedDefaultRegion.id}
                    className="row adm-default-editor">
                    <div className="col-3">
                        <label htmlFor="editRegion" className="form-label text-nowrap">Region</label>
                        <input className="form-control" id="editRegion" defaultValue={selectedDefaultRegion.regionName}
                            maxLength={50} autoComplete={"off"} disabled={!!selectedDefaultRegion.regionName}
                            onChange={(e) => {
                                editDefaultRegion.regionName = e.target.value;
                                checkHasChanges();
                            }}></input>
                    </div>
                    <div className="col-3">
                        <label htmlFor="editDescription" className="form-label text-nowrap">Description</label>
                        <input className="form-control" id="editDescription" defaultValue={selectedDefaultRegion.regionDescription}
                            maxLength={50} autoComplete={"off"}
                            onChange={(e) => {
                                editDefaultRegion.regionDescription = e.target.value;
                                checkHasChanges();
                            }}></input>
                    </div>
                    <div className="col adm-default-actionbuttons text-nowrap">
                        <button disabled={!anyChanges} className="btn btn-primary"
                            onClick={saveChanges}>Save Changes</button>
                        <button className="btn btn-outline-primary"
                            onClick={cancelChanges}>Cancel</button>
                        <ButtonConfirm enabled={!!selectedDefaultRegion.id} buttonText={"Delete"}
                            confirmTitle={"Default Region"}
                            confirmMessage={`Delete default Region '${selectedDefaultRegion.regionName}'?`}
                            buttonSize={ButtonConfirmSize.Normal}
                            cssClass={"btn btn-outline-danger"} onConfirm={deleteItem} />
                    </div>
                </div>}
        </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <div className="container-fluid adm-default-main">
                <div className='adm-default-buttonbar '>
                    <button disabled={!defaultRegionList} className="btn btn-outline-primary" onClick={reloadData}>Reload</button>
                    <button disabled={!defaultRegionList || (!!selectedDefaultRegion && !selectedDefaultRegion.id)}
                        className="btn btn-outline-primary" onClick={addItem}>Add</button>
                </div>
                {buildEditor()}
                <div className='row adm-default-table-wrapper'>
                    <CclDataTable
                        name={"profilesTable"}
                        tableData={defaultRegionList || []}
                        columnDefinitions={profileColumnDefs}
                        rowSelect={true}
                        onRowSelect={handleRowSelect}
                        onButtonClick={null} />
                </div>
            </div>
            <Toaster title="Default Region" subtitle="" message={toastMessage} key={"defrgntoast"} />
        </React.Fragment>

    )
}
